module.exports = __webpack_public_path__ + "img/school_pic.52a7c89e.png";